<template>


  <div style="overflow: hidden;">


    <div style="overflow: hidden;">


      <v-card-text v-if="!is_initialized">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-card-text>

      <div v-else>

        <div v-if="stats.length == 0">

          <v-alert type="info" class="ma-0" tile prominent>
            <h4> {{$t('dashboard.widget.text.order_stats.everything_is_awesome')}}</h4>
            {{$t('dashboard.widget.text.order_stats.no_orders_need_attention')}}
          </v-alert>

        </div>

        <v-layout row wrap v-else-if="stats.length > 0">



          <v-flex xs12 v-if="getStatus('cart') != false">

            <v-card flat color="info">
              <v-card-subtitle class="text-center display-1 white--text">
                {{ getStatus('cart').quantity }}
              </v-card-subtitle>

              <v-card-text class="text-center white--text">{{ getStatus('cart').label }}</v-card-text>
            </v-card>

          </v-flex>

          <v-flex xs12>

            <v-layout>
              <v-flex v-if="getStatus('pending') != false">

                <v-card flat color="grey" tile class="text-center ">


                  <v-card-subtitle class="text-center display-1 white--text">{{ getStatus('pending').quantity }}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{ getStatus('pending').label }}</v-card-text>


                </v-card>

              </v-flex>

              <v-flex v-if="getStatus('on-hold') != false">

                <v-card flat color="warning" tile class="text-center">


                  <v-card-subtitle class="text-center display-1 white--text">{{ getStatus('on-hold').quantity }}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{ getStatus('on-hold').label }}</v-card-text>


                </v-card>

              </v-flex>

              <v-flex v-if="getStatus('pending-confirmation') != false">

                <v-card flat color="error" tile class="text-center ">


                  <v-card-subtitle class="text-center display-1 white--text">{{
                      getStatus('pending-confirmation').quantity
                    }}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{ getStatus('pending-confirmation').label }}
                  </v-card-text>


                </v-card>

              </v-flex>

            </v-layout>


          </v-flex>

          <v-flex xs12>

            <v-layout>

              <v-flex v-if="getStatus('confirmed') != false">

                <v-card flat color="green" tile class="text-center ">


                  <v-card-subtitle class="text-center display-1 white--text">{{
                      getStatus('confirmed').quantity
                    }}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{ getStatus('confirmed').label }}
                  </v-card-text>


                </v-card>

              </v-flex>

              <v-flex v-if="getStatus('processing') != false">


                <v-card flat color="green" tile class="text-center">


                  <v-card-subtitle class="text-center display-1 white--text">{{ getStatus('processing').quantity
                    }}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{ getStatus('processing').label }}
                  </v-card-text>


                </v-card>


              </v-flex>

              <v-flex v-if="getStatus('preparing-for-shipment') != false">


                <v-card flat color="info" tile class="text-center">


                  <v-card-subtitle class="text-center display-1 white--text">
                    {{getStatus('preparing-for-shipment').quantity}}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{getStatus('preparing-for-shipment').label}}
                  </v-card-text>


                </v-card>

              </v-flex>

              <v-flex v-if="getStatus('order-in-transit') != false">


                <v-card flat color="blue lighten-3" tile class="text-center">


                  <v-card-subtitle class="text-center display-1 white--text">
                    {{getStatus('order-in-transit').quantity}}
                  </v-card-subtitle>
                  <v-card-text class="text-center white--text">{{getStatus('order-in-transit').label}}
                  </v-card-text>


                </v-card>

              </v-flex>

            </v-layout>

          </v-flex>

          <v-flex xs12 v-if="getStatus('imported') != false">

            <v-card flat color="grey">
              <v-card-subtitle class="text-center display-1 white--text">{{ getStatus('imported').quantity }}
              </v-card-subtitle>
              <v-card-text class="text-center white--text">{{ getStatus('imported').label }}</v-card-text>
            </v-card>

          </v-flex>

        </v-layout>

      </div>

    </div>



  </div>


</template>


<script>


export default {


  name: 'orderStatsWidget',
  wconf: {

    title: 'dashboard.widget.title.order_stats',
    location: 'primary',
    position: 20,
    active: true,
    roles: ['order_manager','shipping_manager']

  },

  data() {

    return {

      stats: [],
      is_initialized: false,
      interval: null,

      used_stats: [

        'cart',
        'pending',
        'on-hold',
        'pending-confirmation',
        'confirmed',
        'processing',
        'preparing-for-shipment',
        'order-in-transit',
        'imported',


      ]

    }

  },

  methods: {


    getTitle() {

      return this.$t('dashboard.widget.title.order_stats')

    },



    loadOrderStats: function () {


      let self = this;

      let postdata = {
        "object": "order",
        "scope": [
          "facets"
        ],
        "params": {
          "query": {
            "status": [
              'cart',
              'pending',
              'on-hold',
              'pending-confirmation',
              'confirmed',
              'processing',
              'preparing-for-shipment',
              'order-in-transit',
              'imported',
            ]
          },
          "expand": [],
          "facets": [
            "status"
          ]
        },
      };

      self.$http.post('/api/v3/search', postdata).then((result) => {

        let stats = result.data.payload.facets.find(fct => fct.field_id === 'status');
        stats = stats.data.filter(stt => self.used_stats.indexOf(stt.value) !== -1);

        self.stats = stats;
        self.is_initialized = true;

      });


    },


    getStatus: function (status) {

      let index = this.stats.findIndex(item => item.value == status);

      if (index === -1) {
        return false;
      }
      return this.stats[index];

    }

  },

  computed: {},
  destroyed: function () {

    let self = this;
    clearInterval(self.interval);


  },
  mounted: function () {

    let self = this;
    self.loadOrderStats();
    self.interval = setInterval(function () {
      self.loadOrderStats()
    }, 30000);


  },


}


</script>
